(function($) {

  $(document).ready(function() {

    if ($.fn.imgcolr) {

      // Brand header
      var imgs = $('.brand-round');

      imgs.imgcolr();

      // Featured logo
      var feat = $('.featured-logo img');

      feat.imgcolr();

      // Pagebuilder
      var brandImg = $('.brand-logo').find('img');

      brandImg.imgcolr().parent().css({
        'width': 'auto',
        'padding': '1.5rem',
        'border-radius': '50%',
        'box-shadow': '0 0.25rem 0.75rem rgba(0, 0, 0, 0.4)',
        'overflow': 'hidden',
        'transition': 'background-color 0.1s ease'
      });

    }

  });

})(jQuery);
